<template>
  <div>
    <a-row :gutter="20">
      <a-col :span="12">
        <div class="ant-form-item-label">
          <label>{{ titles[0] }}</label>
        </div>
      </a-col>
      <a-col :span="12">
        <div class="ant-form-item-label">
          <label class="ml-4">{{ titles[1] }}</label>
        </div>
      </a-col>
    </a-row>
    <a-transfer :dataSource="mockData" :targetKeys="targetKeys" :selectedKeys="selectedKeys" :render="(item) => item.title" :disabled="disabled" :filterOption="filterOption" showSearch @change="handleChange" @selectChange="handleSelectChange" @search="handleSearch">
    </a-transfer>
  </div>
</template>
<script>
  import { get } from 'lodash';
  export default {
    name: 'Transfer',
    props: {
      titles: {
        type: Array,
        default: function () {
          return ['Source', 'Target'];
        }
      },
      mockData: {
        type: Array,
        default: function () {
          return [];
        }
      },
      disabled: {
        type: Boolean,
        default: false
      },
      selectedItem: {
        type: Array,
        default: function () {
          return [];
        }
      },
      keyFilter: {
        type: String,
        default: 'title'
      }
    },
    data() {
      return {
        selectedKeys: [],
        targetKeys: []
      };
    },
    created() {
      this._prefillSynced = false;
    },
    watch: {
      selectedItem: {
        immediate: true,
        handler(newVal) {
          if (Array.isArray(newVal)) {
            this.targetKeys = this._.cloneDeep(newVal);
          }
        }
      },
      mockData: {
        handler() {
          if (!this._prefillSynced && Array.isArray(this.selectedItem) && this.selectedItem.length > 0) {
            this.targetKeys = this._.cloneDeep(this.selectedItem);
            this._prefillSynced = true;
          }
        }
      }
    },
    methods: {
      handleChange(nextTargetKeys) {
        this.targetKeys = nextTargetKeys;
        this.$emit('change', this.targetKeys);
      },
      handleSelectChange(sourceSelectedKeys, targetSelectedKeys) {
        this.selectedKeys = [...sourceSelectedKeys, ...targetSelectedKeys];
      },
      filterOption(inputValue, option) {
        const targetOpt = get(option, this.keyFilter);
        return targetOpt.indexOf(inputValue) > -1;
      },
      handleSearch() {
      }
    }
  };
</script>
<style lang="scss">
  .ant-transfer-list {
    width: calc(50% - 23px);
  }
</style>
